// Compares "x.y.z" strings. Returns true only when `required` is a valid version and `current`
// is strictly older. Any missing or malformed value returns false so a misconfigured build can
// never reload itself in a loop.
const parse = v => {
  if (typeof v !== 'string' || !/^\d+(\.\d+)*$/.test(v.trim())) return null;
  return v
    .trim()
    .split('.')
    .map(Number);
};

export const isVersionBelow = (current, required) => {
  const a = parse(current);
  const b = parse(required);
  if (!a || !b) return false;
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i += 1) {
    const x = a[i] || 0;
    const y = b[i] || 0;
    if (x !== y) return x < y;
  }
  return false;
};

const RELOADED_KEY = 'delyzon:reloadedForVersion';

// Reloads the page at most once per required version, so a stale cached index.html cannot
// trigger an endless reload loop. Returns true when a reload was triggered.
export const reloadIfOutdated = (current, required, win = window) => {
  if (!isVersionBelow(current, required)) return false;
  let already = null;
  try {
    already = win.sessionStorage.getItem(RELOADED_KEY);
  } catch (e) {
    // sessionStorage can be unavailable (privacy mode); reload once anyway.
  }
  if (already === required) return false;
  try {
    win.sessionStorage.setItem(RELOADED_KEY, required);
  } catch (e) {
    // ignore
  }
  win.location.reload();
  return true;
};
